export default function EntryHintInfo({ children }) {
  if (!children) return null;
  return <p className="lz-workout-entry-hint">{children}</p>;
}
